/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { OverflowCarousel } from '@coursera-web/cds-labs';

import { breakpoints } from '@coursera/cds-core';

import type { PromoTemplateCannedCollectionFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import Section from 'bundles/front-page/components/Section';
import MerchandisingBucket from 'bundles/front-page/redesign-modules/merchandising-buckets/MerchandisingBucket';
import getMerchandisingBuckets from 'bundles/front-page/redesign-modules/merchandising-buckets/data/getMerchandisingBuckets';
import normalizeBucketsModuleContent from 'bundles/front-page/utils/normalizeBucketsModuleContent';

type Props = {
  content?: PromoTemplateCannedCollectionFragment;
};

const style = {
  bucketsGrid: css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    gap: var(--cds-spacing-200);
    width: 100%;

    ${breakpoints.down('xs')} {
      /* 600 / 3 = 200 */
      grid-template-columns: repeat(3, minmax(200px, 1fr));
      width: auto;
    }
  `,
};

const MerchandisingBucketsModuleRenderer = ({ content }: Props) => {
  const buckets = content ? normalizeBucketsModuleContent(content) : getMerchandisingBuckets();

  if (!buckets || !buckets.length) return null;

  return (
    <Section dataTestId="merchandising-buckets" stickToPrevious={!!content?.stickToPrevious}>
      <OverflowCarousel css={style.bucketsGrid} shouldAllowSpaceForHoverItems>
        {buckets.map((bucket, index) => {
          return (
            <MerchandisingBucket
              key={bucket.title}
              index={index}
              title={bucket.title}
              linkTo={bucket.linkTo}
              image={bucket.image}
              dataTestId={`merchandising-bucket-${index}`}
            />
          );
        })}
      </OverflowCarousel>
    </Section>
  );
};

export default MerchandisingBucketsModuleRenderer;
